import React, { useEffect, useState } from 'react';
import { MenuItem, Box } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import BarChartIcon from '@mui/icons-material/BarChart';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import SymbolDetailsModal from '../modal/SymbolDetailsModal';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const MenuComponent = ({ closeMenu, onOpenTradeModal, darkMode, onChartClick, onHideSymbol, handleOpenNewDashboard, selectedRow }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t } = useTranslation()
  const { globalSymbolID } = useSelector(state => state.globalSymbol)

  const openModal = () => {
    setIsModalOpen(true);
    //  closeMenu()
    //  setTimeout(() => {
    //   setIsModalOpen(true);
    // }, 0)
  };

  const closeModal = () => {
    setIsModalOpen(false);
    closeMenu()
  };

  useEffect(() => {
    let timeoutId;

    const handleTabChange = () => {
      if (document.visibilityState === "hidden") {
        clearTimeout(timeoutId);
      } else if (document.visibilityState === "visible") {
        timeoutId = setTimeout(() => {
          closeMenu();
        }, 100);
      }
    };
    document.addEventListener("visibilitychange", handleTabChange);
    return () => {
      clearTimeout(timeoutId);
      document.removeEventListener("visibilitychange", handleTabChange);
    };
  }, [closeMenu]);

  const handleHideSymbol = () => {
    onHideSymbol(globalSymbolID);
    closeMenu();
  };

  const handleNewOrderClick = () => {
    if (selectedRow) {
      handleOpenNewDashboard(selectedRow.name, selectedRow.id);
    }
    closeMenu();
  };

  // useEffect(() => {
  //   if (isModalOpen) {
  //     closeMenu();
  //   }
  // }, [isModalOpen]);

  return (
    <>
      <Box p={1} sx={{ backgroundColor: darkMode ? "#273649" : 'var(--white)' }}>
        <MenuItem onClick={handleNewOrderClick}> <AddCircleOutlineIcon sx={{ mr: 2 }} />{t('newDashboard')}</MenuItem>
        <MenuItem onClick={() => { onOpenTradeModal(); closeMenu(); }}> <AddCircleOutlineIcon sx={{ mr: 2 }} />{t('newOrder')}</MenuItem>
        <MenuItem onClick={() => { onChartClick(); closeMenu(); }}><BarChartIcon sx={{ mr: 2 }} />{t('chart')}</MenuItem>
        <MenuItem onClick={handleHideSymbol}> <TaskAltIcon sx={{ mr: 2 }} />{t('hide')}</MenuItem>
        <MenuItem onClick={openModal}> <InfoOutlinedIcon sx={{ mr: 2 }} />{t('symbolDetails')} </MenuItem>

      </Box>

      {isModalOpen && (<SymbolDetailsModal open={isModalOpen} closeModal={closeModal} />)}
    </>
  );
};

export default MenuComponent;